import { Component, OnInit, Inject } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { VestmentColor } from '../../../../objects';
import { VestmentColorEditComponent } from '../vestment-color-edit/vestment-color-edit.component';
import { EditEntityBaseClass } from '../EditEntityBaseClass';
import { VestmentColorService } from '../../services/vestment-color.service';

@Component({
  selector: 'app-vestment-color',
  templateUrl: './vestment-color.component.html',
  styleUrls: ['./vestment-color.component.css']
})
export class VestmentColorComponent implements OnInit {

  public isLoading = false;
  public data: VestmentColor[];

    constructor(
      public dialog: MatDialog,
      private vestmentColorSvc: VestmentColorService
    ) {
     }

  ngOnInit() {
    this.loadElements();
  }

  private loadElements() {
    this.isLoading = true;
    this.vestmentColorSvc.loadEntites().then(
      (data: VestmentColor[]) => {
        this.data = data;
        console.log(this.data);
        this.isLoading = false;
      },
      (err) => {
        console.log("error", err);
        this.isLoading = false;
      }
   );
  }

  public add() {
    // const dialogRef = this.dialog.open(ReligionBranchEditComponent, {});
  }

  public edit(obj: VestmentColor) {

    var modal = this.dialog.open(VestmentColorEditComponent);
    modal.componentInstance.LoadItem(obj.Id);

    modal.afterClosed().subscribe((savedItem: VestmentColor) => {

      console.log("modal closed", savedItem);

      if (savedItem !== undefined) {
       this.loadElements();
      }

    });

  }

  public delete(obj) {
     alert("Delete");
  }


}
